import { render } from "./PromocionRegaloView.vue?vue&type=template&id=ce43f12c&scoped=true"
import script from "./PromocionRegaloView.vue?vue&type=script&lang=js"
export * from "./PromocionRegaloView.vue?vue&type=script&lang=js"

import "./PromocionRegaloView.vue?vue&type=style&index=0&id=ce43f12c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce43f12c"]])

export default __exports__